import React from 'react'
import { Modal } from 'theorem-lib/src/components/molecules/Modal/Modal'
import { useActions, useAppState } from '../../../presenter'

export function CancelTasklistEditModal() {
  const { currentModal } = useAppState()
  const { displayModalAction, displaySlideOutAction } = useActions()

  const onClose = async (e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>) => {
    e.stopPropagation()
    displayModalAction('None')
    displaySlideOutAction('None')
  }

  const onCancel = () => {
    displayModalAction('None')
  }

  return (
    <Modal
      isOpen={currentModal === 'CancelTasklistEditModal'}
      onClose={onCancel}
    >
      <div className='flex flex-col justify-center items-center w-[80vw] sm:w-[558px]'>
        <div className='text-primary-100 text-xl font-semibold mb-2 text-center'>
          Are you sure you want to leave without saving?
        </div>
        <div className='text-primary-300 text-base font-normal text-center mb-6'>
          Changes you have made so far will not be saved.
        </div>
        <div className='flex flex-row'>
          <button type='button' className='button mx-2' onClick={onCancel}>Keep Editing</button>
          <button type='button' className='button cta mx-2' onClick={onClose}>Confirm</button>
        </div>
      </div>
    </Modal>
  )
}
